import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class ExternalLinksSettingsViewModel {
  public url: string;
  public useLegalNotice: boolean;
  public legalTextDE: string;
  public legalTextEN: string;
  public get legalText(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.legalTextEN) ? this.legalTextDE : this.legalTextEN;
  }
}

// Requests
export class ExternalLinksSettingsSyncModel extends SyncModel {
}

/** Only one ExternalLinksSettings exists and it has the id=0 (this const is used for selecting the ExternalLinksSettings) */
export const ExternalLinksSettingsDMKey: number = 0;
// Responses
export class ExternalLinksSettingsDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public url: string;
  public use_legal_notice: boolean;
  public legal_text_de: string;
  public legal_text_en: string;

  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class ExternalLinksSettingsSyncDataModel extends SyncDataModel {
  public external_links_settings: ExternalLinksSettingsDataModel[];
  public get models(): DataModel[] { return this.external_links_settings; }
  public DeserializeType(): void {
    this._DeserializeType(ExternalLinksSettingsDataModel);
  }
}
